<template>
  <section class="cta-banner">
    <div class="cta-banner__container">
      <h2 class="cta-banner__title">
        {{ currentContent.h1 }}
      </h2>
      <p class="cta-banner__subtitle">
        {{ currentContent.h2 }}
      </p>
      <Button 
        label="Comenzar Ahora" 
        class="cta-banner__button"
        icon="pi pi-arrow-right"
        iconPos="right"
        @click="emit('cta-click')"
      />
    </div>
  </section>

</template>

<script setup>
import { ref, onMounted } from 'vue'
import Button from 'primevue/button'

const emit = defineEmits(['cta-click'])

const contentVariants = [
  {
    h1: 'La infraestructura inteligente para tu estrategia de email.',
    h2: 'Valida cada contacto, crea con IA y automatiza flujos que escalan tus ingresos con precisión quirúrgica.'
  },
  {
    h1: 'Domina la ciencia de llegar al Inbox.',
    h2: 'Asegura tu reputación con validación avanzada y convierte cada envío en una oportunidad real mediante automatización visual.'
  },
  {
    h1: 'Tu motor integral de crecimiento por correo electrónico.',
    h2: 'Desde la limpieza de listas hasta jornadas de cliente automatizadas; todo lo que necesitas para vender más en una sola plataforma.'
  }
];

const currentContent = ref(contentVariants[0]);

onMounted(() => {
  // Get or set the session variant
  const storageKey = 'cta_banner_variant';
  let variantIndex = sessionStorage.getItem(storageKey);
  
  if (variantIndex === null) {
    // First visit this session - pick a random variant
    variantIndex = Math.floor(Math.random() * contentVariants.length);
    sessionStorage.setItem(storageKey, variantIndex.toString());
  } else {
    variantIndex = parseInt(variantIndex, 10);
  }
  
  currentContent.value = contentVariants[variantIndex];
});
</script>

<style lang="scss" scoped>
@import '@/design-system/variables';

// ===========================================
// CTA BANNER SECTION
// ===========================================

.cta-banner {
  padding: $tl-space-20 0;
  background: $tl-white;
  position: relative;
  overflow: hidden;
  border-bottom: 1px solid $tl-platinum;
}

.cta-banner__container {
  max-width: 900px;
  margin: 0 auto;
  padding: 0 $tl-space-6;
  text-align: center;
  position: relative;
  z-index: 1;
}

// ===========================================
// TYPOGRAPHY
// ===========================================

.cta-banner__title {
  font-size: clamp(2rem, 5vw, 3.5rem);
  font-weight: $tl-font-weight-bold;
  color: $tl-jet;
  margin-bottom: $tl-space-5;
  line-height: 1.15;
  letter-spacing: -0.02em;
}

.cta-banner__subtitle {
  font-size: clamp(1rem, 2vw, 1.25rem);
  color: $tl-davys-gray;
  margin-bottom: $tl-space-8;
  line-height: 1.6;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}

// ===========================================
// BUTTON
// ===========================================

.cta-banner__button {
  background: $tl-primary !important;
  color: $tl-white !important;
  border: 2px solid $tl-primary !important;
  padding: $tl-space-4 $tl-space-8 !important;
  font-size: $tl-font-size-base !important;
  font-weight: $tl-font-weight-semibold !important;
  border-radius: $tl-radius-full !important;
  transition: all 0.3s ease !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  
  &:hover {
    background: $tl-primary-600 !important;
    border-color: $tl-primary-600 !important;
    transform: translateY(-2px);
    box-shadow: 0 10px 30px rgba($tl-primary, 0.3);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  :deep(.p-button-icon) {
    margin-left: $tl-space-2;
  }
}

// ===========================================
// RESPONSIVE
// ===========================================

@media (max-width: 768px) {
  .cta-banner {
    padding: $tl-space-16 0;
  }
  
  .cta-banner__title {
    margin-bottom: $tl-space-4;
  }
  
  .cta-banner__subtitle {
    margin-bottom: $tl-space-6;
  }
}
</style>
